import { subscriptionConfigs } from '../config/subscriptionData';
import { categoryIcons } from '../config/subscriptionIcons';

export const getSubscriptionIcon = (serviceName, category) => {
  const serviceIcon = getIconForService(serviceName);
  if (serviceIcon) return serviceIcon;
  
  return getIconForCategory(category);
};

export const getCategoryColor = (category) => {
  const colorMap = {
    streaming: 'bg-red-500',
    music: 'bg-pink-500',
    gaming: 'bg-purple-500',
    productivity: 'bg-blue-500',
    cloud: 'bg-sky-500',
    business: 'bg-indigo-500',
    creative: 'bg-violet-500',
    education: 'bg-green-500',
    fitness: 'bg-emerald-500',
    wellness: 'bg-teal-500',
    security: 'bg-slate-500',
    shopping: 'bg-orange-500',
    dating: 'bg-rose-500',
    entertainment: 'bg-amber-500',
    sports: 'bg-lime-500',
    news: 'bg-cyan-500',
    other: 'bg-gray-500'
  };

  return colorMap[category.toLowerCase()] || colorMap.other;
};

export const getIconById = (iconId) => {
  const config = subscriptionConfigs.find(config => config.id === iconId);
  return config?.icon;
};

export const getIconForService = (serviceName) => {
  const config = subscriptionConfigs.find(config => 
    config.id.toLowerCase() === serviceName.toLowerCase()
  );
  return config?.icon;
};

export const getIconForCategory = (category) => {
  return categoryIcons[category.toLowerCase()] || categoryIcons.other;
};

export const getAllIcons = () => {
  return subscriptionConfigs;
}; 